<template>
  <v-card v-if="workingQualRewardGroup">
    <v-card-title>
      <v-container>
        <v-row ref="qualRewardGroupTitle">
          <v-col cols="6">Level {{workingQualRewardGroup.level}} {{workingQualRewardGroup.level === 0 ?'(Non-Qualifying)' : '' }} Reward Set</v-col>
          <v-col cols="6" class="text-right" v-if="!isSaverProduct() && workingQualRewardGroup.level !== 0" ref="levelMovementControls">
            <v-btn text icon ref="levelUpBtn" :disabled="workingQualRewardGroup.level < 2 || !isEditable" @click="onLevelUp"><v-icon>fa-chevron-up</v-icon></v-btn>
            <v-btn text icon ref="levelDownBtn" :disabled="isLast || !isEditable" @click="onLevelDown"><v-icon>fa-chevron-down</v-icon></v-btn>
            <v-btn text icon ref="levelDeleteBtn" @click="onLevelDelete" :disabled="!isEditable"><v-icon>fa-times</v-icon></v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-title>
    <v-card-text>
      <template v-if="workingQualRewardGroup.level !== 0">
        <v-row v-if="!isFixedQualifierProduct()" class="mx-2 pa-1 qualLogicPanel" align="center" ref="qualLogicPanel">
          <v-col>
            Qualification Logic:  {{friendlyLogicName[workingQualRewardGroup.qualificationLogic]}}<br/>
            Autoqualify: {{workingQualRewardGroup.autoQualifyCycles}} {{workingQualRewardGroup.autoQualifyCycles === 1 ? 'cycle' : 'cycles'}}
          </v-col>
          <v-col class="text-right">
            <edit-logic-dialog
                :logic="workingQualRewardGroup.qualificationLogic"
                :autoQualifyCycles="workingQualRewardGroup.autoQualifyCycles"
                @save="onNewLogic"
                :isEditable="isEditable"/>
          </v-col>
        </v-row>
        <v-row v-if="isIncontrolBurnDown()" class="mx-2" ref="accountIsOpenNotice">
          <h4>Account is Open</h4>
        </v-row>
        <v-row v-if="workingQualRewardGroup.qualifiers.length > 0">
          <v-col cols="12">
            <v-data-table :items = "workingQualRewardGroup.qualifiers" :headers="qualTableHeaders" :hide-default-footer="true" class="innerTable" ref="qualifierTable">
              <template v-slot:item="{ item, index }">
                  <tr>
                    <td><edit-qualification-dialog
                          :smallIcon="true"
                          v-if="!isFixedQualifierProduct()"
                          v-model="workingQualRewardGroup.qualifiers[index]"
                          :productType="productType"
                          @input="onEditQualification"
                          :isEditable="isEditable"
                          :productTypes="productTypes"
                          :productMappings="productMappings"
                          :accountProductTypes="accountProductTypes"
                          />
                      {{ item.getDescription(productTypes, productMappings) }}</td>
                    <td>
                      <v-progress-circular indeterminate v-if="item.validationErrors === null"/>
                      <span v-else-if="item.validationErrors && item.validationErrors.length === 0">
                        <v-icon color='success'>fa-check</v-icon>
                      </span>
                      <span v-else>
                        <v-icon color="error" class="mr-2">fa-times</v-icon>
                        <span v-for='failure in item.validationErrors' v-bind:key='failure' class="mr-2">
                          <router-link class="failureLink" :to="{name: getFailure(failure).location}">{{getFailure(failure).message}}</router-link>
                        </span>
                      </span>
                    </td>
                    <td class="text-right">
                      <v-btn text icon @click="removeQualifier(index)" v-if="!isFixedQualifierProduct()" :disabled="!isEditable"><v-icon>fa-trash</v-icon></v-btn>
                    </td>
                  </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <edit-qualification-dialog
              v-if="!isFixedQualifierProduct()"
              :productType="productType"
              @input="onNewQualification"
              ref="newQualifierButton"
              :isEditable="isEditable"
              :productTypes="productTypes"
              :productMappings="productMappings"
              :accountProductTypes="accountProductTypes"/>
          </v-col>
        </v-row>
      </template>
      <v-row v-if="workingQualRewardGroup.rewards.length > 0">
        <v-col cols="12">
          <v-data-table :items = "workingQualRewardGroup.rewards" :headers="rewardTableHeaders" :hide-default-footer="true" class="innerTable" ref="rewardTable">
            <template v-slot:item="{ item, index }">
                <tr>
                  <td><edit-reward-dialog
                    :smallIcon="true"
                    v-model="workingQualRewardGroup.rewards[index]"
                    :productType="productType"
                    :level="value.level"
                    :baseLevelRewardsPct="baseLevelRewardsPct"
                    :lowestRewardsPct="lowestRewardsPct"
                    :atmSetting="atmSetting"
                    :productHasInterestReward="productHasInterestReward"
                    @input="onEditReward"
                    :rewardTypeDisabled="isLevelZero() || item.id !== null"
                    :isEditable="isEditable"/>
                    {{ item.getDescription() }}</td>
                  <td>
                    <v-progress-circular indeterminate v-if="item.validationErrors === null"/>
                    <span v-else-if="item.validationErrors && item.validationErrors.length === 0">
                      <v-icon color='success'>fa-check</v-icon>
                    </span>
                    <span v-else>
                      <v-icon color="error" class="mr-2">fa-times</v-icon>
                      <span v-for='failure in item.validationErrors' v-bind:key='failure' class="mr-2">
                         <router-link class="failureLink" :to="{name: getFailure(failure).location}">{{getFailure(failure).message}}</router-link>
                      </span>
                    </span>
                  </td>
                   <td class="text-right">
                    <v-btn text icon @click="removeReward(index)" v-if="!isSaverProduct()" :disabled="!isEditable"><v-icon>fa-trash</v-icon></v-btn>
                  </td>
                </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
        <v-row v-if="!isSaverProduct() && !isLevelZero()" >
          <v-col cols="12">
            <edit-reward-dialog
            :productHasInterestReward="productHasInterestReward"
            :productType="productType"
            :level="value.level"
            :baseLevelRewardsPct="baseLevelRewardsPct"
            :lowestRewardsPct="lowestRewardsPct"
            :atmSetting="atmSetting"
            @input="onNewReward"
            ref="newRewardButton"
            :isEditable="isEditable"/>
          </v-col>
        </v-row>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapState } from 'vuex';
import {
  Component, Inject, Prop, Watch,
} from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import { Alert, NoticeClass } from '@kasasa/fbase-components/lib';
import { ProductResource, ValidationResult } from '@/api/product/';
import { ProductTypeMap } from '@/api/producttypes';
import { AccountProductTypeMap } from '@/api/accountproducttypes';
import { ProductMapping } from '@/api/productmapping';
import { QualRewardGroup } from '@/api/product/levelrewards';
import { IQualifier } from '@/api/product/levelrewards/qualifiers';
import { IReward, InterestReward } from '@/api/product/levelrewards/rewards';
import { ATM } from '@/api/atmsettings';
import EditLogicDialog from './EditLogicDialog.vue';
import EditQualificationDialog from './qualifications/EditQualificationDialog.vue';
import EditRewardDialog from './rewards/EditRewardDialog.vue';

@Component({
  computed: mapState(['fiId']),
  components: {
    EditLogicDialog,
    EditQualificationDialog,
    EditRewardDialog,
  },
})
export default class QualRewardGroupPanel extends Vue {
  @Prop() value!: QualRewardGroup;

  @Prop() productType!: string;

  @Prop() isLast!: boolean;

  @Prop() productHasInterestReward!: boolean;

  @Prop({ default: false }) isEditable!: boolean;

  @Prop()
  productTypes!: ProductTypeMap;

  @Prop()
  productMappings!: ProductMapping[];

  @Prop()
  accountProductTypes!: AccountProductTypeMap;

  @Prop()
  atmSetting!: ATM | null;

  @Prop()
  baseLevelRewardsPct!: number | null;

  @Prop()
  lowestRewardsPct!: number | null;

  @Inject('ProductResource')
  productResource!: ProductResource;

  workingQualRewardGroup: QualRewardGroup | null = null;

  fiId!:string;

  friendlyLogicName:any = {
    AND: 'And',
    OR: 'Or',
  }

   qualTableHeaders: DataTableHeader[] = [
     {
       text: 'Qualification', value: '', align: 'start', sortable: false, width: '40%',
     },
     {
       text: 'Setup', value: '', align: 'start', sortable: false, width: '50%',
     },
     {
       text: '', value: '', align: 'start', sortable: false, width: '10%',
     },
   ];

    rewardTableHeaders: DataTableHeader[] = [
      {
        text: 'Reward', value: '', align: 'start', sortable: false, width: '40%',
      },
      {
        text: 'Setup', value: '', align: 'start', sortable: false, width: '50%',
      },
      {
        text: '', value: '', align: 'start', sortable: false, width: '10%',
      },
    ];

    mounted() {
      this.onNewQualRewardGroup();
    }

    @Watch('value.level')
    onLevelChange() {
      this.workingQualRewardGroup!.level = this.value.level;
    }

    onNewQualRewardGroup() {
      this.workingQualRewardGroup = ProductResource.createEmptyQualRewardGroup();
      Object.assign(this.workingQualRewardGroup, this.value);
      this.workingQualRewardGroup.qualifiers.forEach((qualifier:IQualifier) => {
        this.validateQualifier(qualifier);
      });

      this.workingQualRewardGroup.rewards.forEach((reward:IReward) => {
        this.validateReward(reward);
      });
    }

    onChange() {
      this.$emit('input', this.workingQualRewardGroup);
    }

    validateQualifier(qualifier:IQualifier) {
      /* eslint-disable no-param-reassign */
      qualifier.validationErrors = null;
      /* eslint-enable no-param-reassign */

      this.productResource.validateQualifier(this.fiId, qualifier).then((result:ValidationResult) => {
        /* eslint-disable no-param-reassign */
        qualifier.validationErrors = result.failures;
        (qualifier as any).hasErrors = true;
      /* eslint-enable no-param-reassign */
      }).catch((error:any) => {
        this.showError(error);
      });
    }

    validateReward(reward:IReward) {
    /* eslint-disable no-param-reassign */
      reward.validationErrors = null;
      /* eslint-enable no-param-reassign */

      this.productResource.validateReward(this.fiId, reward).then((result:ValidationResult) => {
      /* eslint-disable no-param-reassign */
        reward.validationErrors = result.failures;
        (reward as any).hasErrors = true;
      /* eslint-enable no-param-reassign */
      }).catch((error:any) => {
        this.showError(error);
      });
    }

  getFailure = (failureType:string) : any => {
    switch (failureType) {
      case 'UNMAPPED_TRANSACTION_CLASSIFICATIONS':
        return {
          location: 'transactionclassification',
          message: 'Unmapped Transaction Classification(s)',
        };
      case 'UNMAPPED_STATEMENT_CODES':
        return {
          location: 'statementcodemappingsrules',
          message: 'Unmapped Statement Code(s)',
        };
      case 'UNCONFIGURED_ATM_SETTINGS':
        return {
          location: 'atmsettings',
          message: 'Unconfigured ATM Settings',
        };
      default:
        throw new Error(`unsupported failure type: ${failureType}`);
    }
  }

  isSaverProduct() : boolean {
    return this.productType === 'KASASA_SAVER';
  }

  isIncontrolBurnDown() : boolean {
    return this.productType === 'INCONTROL_BURN_DOWN';
  }

  isFixedQualifierProduct() : boolean {
    return this.isSaverProduct() || this.isIncontrolBurnDown();
  }

  isLevelZero() : boolean {
    return this.workingQualRewardGroup?.level === 0;
  }

  removeQualifier(index:number) {
    this.workingQualRewardGroup!.qualifiers.splice(index, 1);
    this.onChange();
  }

  removeReward(index:number) {
    this.workingQualRewardGroup!.rewards.splice(index, 1);
    this.$emit('rewardDeleted');
    this.onChange();
  }

  onNewQualification(newQual: IQualifier) {
    this.workingQualRewardGroup!.qualifiers.push(newQual);
    this.validateQualifier(newQual);
    this.onChange();
  }

  onNewReward(newReward: IReward) {
    // If the new reward is interest and we specified a non-qual apr, emit an event to ensure that level zero exists.
    /* eslint-disable no-underscore-dangle */
    if (newReward._class === InterestReward.CLASS && (newReward as InterestReward).nonQualifyingApr) {
    /* eslint-enable no-underscore-dangle */
      this.$emit('newNonQualApr', (newReward as InterestReward).nonQualifyingApr);
      /* eslint-disable no-param-reassign */
      (newReward as InterestReward).nonQualifyingApr = null;
      /* eslint-able no-param-reassign */
    }


    this.workingQualRewardGroup!.rewards.push(newReward);
    this.validateReward(newReward);
    this.onChange();
  }

  onEditQualification(editedQual: IQualifier) {
    this.validateQualifier(editedQual);
    this.onChange();
  }

  onEditReward(editedReward: IReward) {
    this.validateReward(editedReward);
    this.onChange();
  }

  onNewLogic(logic:string, autoQualifyCycles: number) {
    this.workingQualRewardGroup!.qualificationLogic = logic;
    this.workingQualRewardGroup!.autoQualifyCycles = autoQualifyCycles;
    this.onChange();
  }

  onLevelUp() {
    this.$emit('levelUp');
  }

  onLevelDown() {
    this.$emit('levelDown');
  }

  onLevelDelete() {
    this.$emit('levelDelete');
  }

  showError(error: any) {
    console.error(error);
    if (error.response && error.response.data && error.response.data.entity) {
      this.setError(error.response.data.entity);
    } else {
      this.setError('An unexpected error occurred.');
    }
  }

  setError(message: string) {
    const al = new Alert(message, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
</script>
<style lang="scss">
.qualLogicPanel {
  background: #eeeeee !important;
  border: 1px solid #cfcfcf;
  color: black;
}

tbody tr:nth-of-type(odd) {
   background-color: rgba(31, 25, 25, 0.02);
   background-blend-mode: multiply;
 }

 .innerTable {
   border: 1px solid #cfcfcf;
 }

 .failureLink {
   text-decoration: none;
 }
</style>
